<template>
  <div class="convert-main">
    <div class="convert-main-head">
      <img src="../../assets/H5/convert-bac.png" alt="">
    </div>
    <div class="convert-main-content">
      <div class="convert-main-content-upload-border">
        <div class="uploads-main">
          <el-form
              ref="uploadForm"
              :rules="uploadrules"
              :model="uploadform"
              :inline="true"
              class="demo-form-inline"
          >
            <div @click="getUserStatus" data-track-text="上传PDF转换文件" aria-label="上传PDF转换文件">
              <el-upload
                  class="new-upload-demo"
                  :disabled="isUploadDisabled"
                  action
                  drag
                  multiple
                  ref="fileUpload"
                  :class="elUploadMdjy"
                  accept=".pdf"
                  :limit="count"
                  :on-exceed="onExceed"
                  :file-list="fileList"
                  :auto-upload="autoUpload"
                  :before-upload="beforeUpload"
                  :http-request="submitUploadFiles"
                  :on-error="onError"
                  :on-success="onSuccess"
                  :on-remove="handleRemove"
              >
                <div :class="elUploadMdjy">
                  <div class="content">
                    <div class="el-upload-titjy">
                      拖入/选择 要转换的文档
                      <span style="color: #999999">（可批量上传）</span>
                    </div>
                    <div class="scbncg">
                      <span style="color: #999999;font-size: 14px;">上传文档不能超过20M</span>
                    </div>
                    <div class="uptitle">
                      确认转换
                    </div>
                    <div class="uptip">
                  <span> 限时优惠，转换
                    <span style="color:#E13C3C;">0.1</span>元/页（原价<span
                        style="color:#E13C3C;">0.3</span>元/页）
                  </span>
                    </div>
                  </div>
                </div>
              </el-upload>
            </div>
          </el-form>
          <!--      <div :class="showupload" v-show="isShowupload">
                  <el-divider v-show="isShowupload">支持以下上传格式</el-divider>
                  <div class="list" v-show="isShowupload">
                    <div>
                      <img src="../assets/img/pdf.png"/>
                      <span class="hit-span2">pdf</span>
                    </div>
                  </div>
                </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  checkRoamingRequest,
  parentPowerRequest, submitConvertRequest,
  translateServiceClient, uploadConvertPDFRequest, uploadCountRequest,
  uploadTipRequest
} from "@/tools/api/translate-api";
import {authServiceClient} from "@/tools/api/service";
import {outRequest, thirdLoginRequest, userPowerRequest, userStatusRequest} from "@/tools/api/auth-api";
import {Base64} from "js-base64";

export default {
  name: "Convert",
  data() {
    return {
      isShowTransPro: false,
      isShowMoney: false,
      isShowFree: false,
      orderMoney: 0,
      moneys: 0,
      pages: 0,
      idData: [],
      dialogTableVisible: false,
      gridData: [],
      uploadCount: 0,
      limitCount: 20,
      count: 10,
      isUploadDisabled: true,
      isImgUploadDisabled: true,
      isShowupload: true,
      showupload: "new-el-upload-manjy",
      elUploadMdjy: "new-el-upload-mdjy",
      showUpload1: true,
      showUpload2: true,
      timer: "",
      autoUpload: true,
      hasUpload: false,
      uploadform: {
        from: "auto",
        to: "zh",
      },
      uploadrules: {
        from: [{required: true, message: "请输入原文语言", trigger: "blur"}],
        to: [{required: true, message: "请输入目标语言", trigger: "blur"}],
      },
      fileList: [],
      uploaddemo: "new-upload-demo",
      uploadLoading: false,
      one: true,
      two: false,
      three: false,
      four: false,
      one2: true,
      two2: false,
      three2: false,
      lastTime: 0,
    }
  },
  watch: {
    dialogTableVisible(val) {
      if (!val) {
        this.$refs.fileUpload.clearFiles();
        this.$refs.fileUpload.$data.uploadFiles = [];
        this.idData = [];
        this.gridData = [];
        this.orderMoney = 0;
        this.moneys = 0;
        this.pages = 0;
        this.isUploadDisabled = false;
        this.elUploadMdjy = "new-el-upload-mdjy";
        this.uploaddemo = "new-upload-demo"
        this.$router.push(
            {
              path: '/h5',
              query: {
                type: "convert"
              }
            }
        )
      } else {
        let request = parentPowerRequest;
        request.setMoney(this.moneys)
        const TOKEN_KEY = "token";
        translateServiceClient.checkParentPower(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        }).then(res => {
          this.isShowMoney = res.getShowmoney();
          if (this.isShowMoney && this.moneys === 0) {
            this.isShowFree = true;
          }
        }).catch(err => {
          this.isShowMoney = true;
        })
      }
    }
  },
  created() {
    this.getUploadTip();
  },
  mounted() {
    const that = this;
    this.checkUploadCountByDay1();
    this.timer = setInterval(function () {
      let x = document.getElementsByClassName("el-progress__text");
      let count = 0;
      for (let i = 0; i < x.length; i++) {
        if (x[i].innerHTML === "100%") {
          count = count + 1;
          console.log(x[i])
          x[i].parentNode.previousSibling.previousSibling.previousSibling.style.display = "block";
        }
      }
      if (x.length !== 0 && count === x.length) {
        clearInterval(that.timer);
        setTimeout(function () {
          that.dialogTableVisible = true;
        }, 1500);
      }
    }, 10);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    getQrcode() {
      this.qrcodeUrl = "http://common.wesitrans.com/common/roaming/qrcode"
      this.isRoamingTimer = setInterval(this.roamingEvent, 1000)
      this.isRoamingTimerOut = setTimeout(this.clearTime, 60000);
    },
    clearTime() {
      clearInterval(this.isRoamingTimer);
      clearTimeout(this.isRoamingTimerOut);
    },
    roamingEvent() {
      if (this.userId && localStorage.getItem(this.userId) !== '1') {
        let request = checkRoamingRequest
        request.setUserId(this.userId)
        const TOKEN_KEY = "token";
        translateServiceClient.checkRoaming(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        }).then(res => {
          localStorage.setItem(this.userId, res.getMessage())
          if (res.getMessage() === '1') {
            window.location.reload()
          }
        }).catch(err => {
        })
      }
    },
    removeQrcode() {
      this.qrcodeUrl = "";
      clearInterval(this.isRoamingTimer);
      clearTimeout(this.isRoamingTimerOut);
    },
    checkUploadCountByDay1() {
      const that = this;
      const TOKEN_KEY = "token";
      translateServiceClient.checkUploadCountByDay(uploadCountRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      })
          .then(res => {
            if (!res.getIsoverstepcount()) {
              that.$message.error(res.getMessage());
              that.isUploadDisabled = true;
              that.isImgUploadDisabled = true;
              that.elUploadMdjy = "new-el-upload-mdjy-none";
              that.limitCount = res.getLimitcount();
              return false;
            }
            that.isUploadDisabled = false;
            that.isImgUploadDisabled = false;
            that.elUploadMdjy = "new-el-upload-mdjy";
            that.uploaddemo = "new-upload-demo"
            if (res.getCount() >= 10) {
              that.count = 10;
              that.limitCount = res.getLimitcount();
              return true;
            }
            that.count = res.getCount();
            that.limitCount = res.getLimitcount();
            return true;
          })
          .catch(err => {
            return false;
          })
    },
    submitUploadFiles(event) {
      let time
      const TOKEN_KEY = "token";
      translateServiceClient.checkUploadCountByDay(uploadCountRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      })
          .then(res => {
            if (!res.getIsoverstepcount()) {
              this.$message.error(res.getMessage());
              this.isUploadDisabled = true;
              this.elUploadMdjy = "new-el-upload-mdjy-none";
              return
            }
            this.isShowupload = false;
            this.isUploadDisabled = false;
            this.elUploadMdjy = "new-el-upload-mdjy";
            if (res.getCount() >= 10) {
              this.count = 10
              this.limitCount = res.getLimitcount();
            } else {
              this.count = res.getCount();
              this.limitCount = res.getLimitcount();
            }
            this.elUploadMdjy = "new-el-upload-mdjy-display";
            this.uploaddemo = "new-upload-demo-none"
            //上传进度
            let unm = 0;
            event.onProgress({percent: unm});
            time = setInterval(function () {
              let Range = 5 - 1;
              let Rand = Math.random();
              unm = 1 + Math.round(Rand * Range) + unm;
              if (unm > 99) {
                unm = 99;
              }
              event.onProgress({percent: unm});
            }, 100);
            const files = this.$refs.fileUpload.$data.uploadFiles;
            const file = files[this.uploadCount];
            this.uploadCount = ++this.uploadCount;
            let request = uploadConvertPDFRequest;
            let reader = new FileReader();
            reader.readAsArrayBuffer(file.raw, "utf-8");
            const thatEvent = event;
            reader.onloadend = () => {
              request.setFile(new Uint8Array(reader.result));
              request.setName(file.name);
              request.setSize(file.size);
              translateServiceClient
                  .uploadConvertPDF(request, {
                    [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
                  })
                  .then((res) => {
                    clearInterval(time);
                    if (res.getStatus()) {
                      thatEvent.onProgress({percent: 100})
                      const file = res.getUploadfile();
                      const data = {};
                      data.id = file.getId();
                      data.title = file.getTitle();
                      data.page = file.getPage();
                      data.money = file.getOrderMoney();
                      this.gridData.push(data);
                      this.moneys = this.moneys + file.getMoney();
                      this.orderMoney = this.orderMoney + file.getOrderMoney();
                      this.pages = this.pages + file.getPage();
                      return;
                    }
                    this.$refs.fileUpload.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUpload.$data.uploadFiles = files;
                    this.$message({
                      center: true,
                      type: 'error',
                      showClose: true,
                      duration: 6000,
                      message: res.getMessage()
                    });
                    if (files.length === 0) {
                      this.isUploadDisabled = false;
                      this.elUploadMdjy = "new-el-upload-mdjy";
                      this.uploaddemo = "new-upload-demo"
                    }
                  })
                  .catch((error) => {
                    this.isShowupload = true;
                    clearInterval(time);
                    if (error && error.code === 5) {
                      localStorage.removeItem("token");
                      localStorage.removeItem("auth-context");
                      this.$router.push("/h5/login");
                      return;
                    }
                    this.$refs.fileUpload.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUpload.$data.uploadFiles = files;
                    this.$message.error("上传文件失败");
                    if (files.length === 0) {
                      this.isUploadDisabled = false;
                      this.elUploadMdjy = "new-el-upload-mdjy";
                    }
                  });
            };
          }).catch(err => {
        this.isShowupload = true;
        clearInterval(time);
        if (err.code === 5) {
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          this.$router.push("/h5/login");
        } else {
          this.$message.error("文件上传遇到了问题，请稍后再试！");
        }
      })
    },
    submitPay() {
      const ids = [];
      this.gridData.forEach((item, index) => {
        ids.push(item.id)
      })
      let request = submitConvertRequest;
      request.setIdsList(ids).setMoney(this.moneys);
      const TOKEN_KEY = "token";
      translateServiceClient.submitConvert(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        if (res.getStatus()) {
          if (res.getMessage() !== undefined && res.getMessage() !== null && res.getMessage() !== "") {
            window.open(res.getMessage(), "_self");
            return;
          }
          this.$router.push(
              {
                path: '/list',
                query: {
                  type: "convert"
                }
              }
          )
          return
        }
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: res.getMessage()
        });
      }).catch(err => {
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: "提交失败请稍后再试"
        });
      })
    },
    onSuccess() {
      return false;
    },
    handleRemove(file) {
      this.$refs.fileUpload.abort(); //取消上传
      this.$refs.fileUploadImg.abort();
    },
    onError(err, file, fileList) {
    },
    onExceed() {
      if (this.count === 10) {
        this.$message.error("仅支持批量上传10个文件！");
        this.isUploadDisabled = false;
        return;
      }
      if (this.count === 0) {
        this.$message.error("当前账户仅支持24小时内上传" + this.limitCount + "篇文献")
        this.isUploadDisabled = true;
        this.elUploadMdjy = "new-el-upload-mdjy-none";
        this.uploaddemo = "new-upload-demo"
        return;
      }
      this.$message({
        center: true,
        type: 'error',
        dangerouslyUseHTMLString: true,
        message: "<span style='font-size:14px;font-family: Microsoft YaHei;font-weight: 400;color: #EF6C6C;'>当前账户仅支持24小时内上传" + this.limitCount + "篇文献，您还剩余&nbsp;<span style='font-size:20px;'>" + this.count + "</span>&nbsp;篇</span>"
      });
      this.elUploadMdjy = "new-el-upload-mdjy";
      this.uploaddemo = "new-upload-demo"
      this.isUploadDisabled = false;
    },
    beforeUpload(file) {
      const testmsg = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();
      const extension = testmsg === "pdf";
      if (!extension) {
        this.$message.error("暂不支持" + testmsg + "文件类型");
      }
      if (file.size === 0) {
        this.$message.error("您上传的文件内容为空！");
        return false;
      }
      const islimit = file.size < 20971520;
      if (!islimit) {
        this.$message.error("文件上传大小不能超过20M！");
      }
      return extension && islimit;
    },
    getUserStatus() {
      const that = this;
      const TOKEN_KEY = "token";
      authServiceClient
          .getUserStatus(userStatusRequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          }).then((res) => {
        if (!res.getStatus()) {
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          this.$router.push("/h5/login");
          return false;
        }
        const user = localStorage.getItem("auth-context");
        if (!user) {
          this.$router.push("/h5/login");
          return false;
        }
        return that.checkUserPower();
      }).catch((err) => {
        localStorage.removeItem("token");
        localStorage.removeItem("auth-context");
        this.$router.push("/h5/login");
        return false;
      });

    },
    checkUserPower() {
      const that = this;
      const TOKEN_KEY = "token";
      authServiceClient.checkUserPower(userPowerRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      })
          .then(res => {
            if (!res.getStatus()) {
              that.$message({
                center: true,
                type: 'error',
                showClose: true,
                duration: 3000,
                message: res.getMessage()
              });
              this.$router.push("/h5/login");
              return false;
            }
            return that.checkUploadCountByDay();
          }).catch(err => {
        this.$router.push("/h5/login");
        return false;
      })
    },
    checkUploadCountByDay() {
      const that = this;
      const TOKEN_KEY = "token";
      translateServiceClient.checkUploadCountByDay(uploadCountRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      })
          .then(res => {
            if (!res.getIsoverstepcount()) {
              that.$message.error(res.getMessage());
              that.isUploadDisabled = true;
              that.elUploadMdjy = "new-el-upload-mdjy-none";
              that.limitCount = res.getLimitcount();
              return false;
            }
            that.isUploadDisabled = false;
            that.elUploadMdjy = "new-el-upload-mdjy";
            if (res.getCount() >= 10) {
              that.count = 10;
              that.limitCount = res.getLimitcount();
              return true;
            }
            that.count = res.getCount();
            that.limitCount = res.getLimitcount();
            return true;
          })
          .catch(err => {
            if (err.code === 5) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              this.$router.push("/h5/login");
            } else {
              that.$message.error("文件上传遇到了问题，请稍后再试！");
            }
            return false;
          })
    },
    openRecommendations() {
      const width = $(window).width();
      if (width <= 768) {
        layer.open({
          skin: 'login-demo-class',
          area: ['948px', '625px'],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ['/recommendations', 'no'],
        });
      } else {
        layer.open({
          area: ['948px', '625px'],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ['/recommendations', 'no'],
        });
      }
    },
    showTip() {
      const tip = sessionStorage.getItem("payTip");
      if (this.$route.path === "/" || this.$route.path === "/index") {
        if (tip === undefined || tip === null || tip === "") {
          this.payCenterDialogVisible = true;
        }
      }
    },
    checkLogin(code, state) {
      let request = thirdLoginRequest;
      request.setCode(code)
      request.setState(state)
      const TOKEN_KEY = 'token';
      authServiceClient.thirdLogin(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        let status = res.getStatus();
        if (status === "400") {
          this.$message({
            center: true,
            type: 'error',
            showClose: true,
            duration: 3000,
            message: res.getMessage()
          });
          setTimeout(this.toNew, 3000);
          return;
        }
        if (status === "201") {
          let openid = res.getOpenid();
          let type = res.getType();
          this.$router.push({
            name: "Bind",
            params: {openid: openid, type: type}
          })
          return;
        }
        if (status === "200") {
          this.$router.push("/index")
          window.location.reload()
          return;
        }
      }).catch(err => {
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: "登录失败请重试"
        });
      })
    },
    getUrlParameter(route) {
      //decodeURIComponent() 函数可对 encodeURIComponent() 函数编码的 URI 进行解码。
      let url = decodeURIComponent(route).split('?');
      url = url[url.length - 1];
      let obj = {};
      url.split('&').map((query) => {
        let temp = query.split('=');
        obj[temp[0]] = temp[1];
      });
      return obj;
    },
    toPath(url) {
      if (url === '/trans-pro') {
        window.open("/trans-pro/index", "_self")
        return;
      }
      if (url === '/list' || url === '/list-pro') {
        const TOKEN_KEY = 'token';
        authServiceClient.getUserStatus(userStatusRequest, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
        }).then(res => {
          if (!res.getStatus()) {
            localStorage.removeItem("token")
            localStorage.removeItem("auth-context")
            this.$router.push("/h5/login");
            return;
          }
          if (localStorage.getItem('auth-context') &&
              localStorage.getItem('token')) {
            authServiceClient.checkUserPower(userPowerRequest, {
              [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
            }).then(res => {
              if (res.getStatus()) {
                this.$router.push(url)
                return;
              }
              this.$message({
                center: true,
                type: 'error',
                showClose: true,
                duration: 3000,
                message: res.getMessage()
              });
              this.$router.push("/h5/login");
            }).catch(err => {
              this.$router.push("/h5/login");
            })
          }
        }).catch(err => {
          this.$router.push("/h5/login");
        });
        return
      }
      this.$router.push(url);
    },
    openTry() {
      const width = $(window).width();
      if (width <= 768) {
        layer.open({
          skin: 'login-demo-class',
          area: ['948px', '625px'],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ['/try', 'no'],
        });
      } else {
        layer.open({
          area: ['948px', '625px'],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ['/try', 'no'],
        });
      }
    },
  }
}
</script>

<style lang="less" scoped>
/deep/ .new-upload-demo-none {
  .el-upload {
    display: none;
  }
}

/deep/ .new-el-upload-mdjy-display {
  .el-upload {
    display: none;
  }

  margin-left: 60px;
  align-items: end !important;
}

.new-el-upload-mdjy-none {
  background-color: #f5f5f5;
  border: 1px dashed #cccccc;
  width: 350px;
  height: 224px;
  display: inline-block;
  text-align: center;
  padding-top: 20px;
}

.convert-main {
  min-width: 765px;
  width: 100%;
  background: #ffffff;
  display: flex;
  flex-flow: column;
  align-items: center;

  .convert-main-head {
    width: 100%;
    height: 333px;
    background: #F5F5F5;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: flex-end;
  }

  .convert-main-content {
    width: 100%;
    height: 798px;
    background: #FFFFFF;
    display: flex;
    flex-flow: column;
    align-items: center;

    .convert-main-content-upload-border {
      width: 705px;
      height: 798px;
      background: #FFFFFF;
      border: 1px solid #DDDDDD;

      .uploads-main {
        /deep/ .new-upload-demo {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          margin-top: 121px;

          .el-upload-dragger {
            width: 539px;
            height: 365px;
            border: 1px dashed #d9d9d9;

            .new-el-upload-mdjy {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              line-height: 30px;
              cursor: pointer;

              .content {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .el-upload-titjy {
                  margin-top: 60px;
                  width: 433px;
                  height: 40px;
                  font-size: 24px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #333333;
                  line-height: 48px;
                }

                .scbncg {
                  width: 253px;
                  height: 25px;
                  font-size: 24px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #999999;
                  margin-top: 20px;
                }

                .uptitle {
                  margin-top: 40px;
                  width: 261px;
                  height: 60px;
                  border-radius: 35px 0px 35px 0px;
                  align-items: center;
                  justify-content: center;
                  background: #063F95;
                  color: #F5F5F5;
                  font-size: 24px;
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  color: #F5F5F5;
                  line-height: 52px;
                }

                .uptip {
                  margin-top: 28px;
                  width: 382px;
                  height: 21px;
                  font-size: 20px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #999999;
                }
              }
            }
          }

          .el-upload-list {
            margin-bottom: 30px !important;

            .el-upload-list__item .el-progress {
              position: absolute;
              top: 44px;
              width: 100%;
            }
            .el-upload-list__item .el-progress__text{
              font-size: 24px !important;
              margin-top: -16px;
              font-size: 24px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #999999;
            }
            .el-upload-list__item {
              text-align: left;
              transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
              font-size: 14px;
              color: #606266;
              line-height: 1.8;
              margin-top: 20px;
              position: relative;
              box-sizing: border-box;
              border-radius: 4px;
              width: 623px;

              .el-icon-document {
                position: absolute;
                margin-left: -49px;
                margin-top: -2.5px;
                font-size: 45px;
                color: #bebebe;
              }

              .el-upload-list__item-name {
                width: 500px;
                height: 40px;
                font-size: 24px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #999999;
              }

              .el-progress-bar__outer {
                height: 14px !important;
                width: 623px;
              }


              .el-progress-bar__inner {
                background-color: #4dbe92 !important;
                height: 14px;
              }

              .el-icon-upload-success {
                display: none;
                color: #67c23a;
                position: absolute;
                margin-left: 19px;
                margin-top: 7.5px;
                height: 14px;
                font-size: 26px;
              }
            }
          }
        }

        /deep/ .new-el-upload-manjy {
          width: 560px;
          margin-bottom: 40px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .el-divider.el-divider--horizontal {
            width: 470px;
            margin: 0;

            .el-divider__text.is-center {
              font-size: 16px;
              font-family: "Microsoft YaHei";
              color: #999999;
            }
          }

        }

        .list {
          margin-top: 40px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          width: 100%;

          div {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: #999999;

            span {
              margin-top: 10px;
            }
          }
        }
      }
    }
  }
}
</style>
